var _path, _path2, _path3, _path4, _path5, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyState = function SvgEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 57.5c16 14 10.734 34.442 8 39-11.656 19.432-26.5-15.264-17.844-13.932 8.656 1.332-5.656 33.932-22-3.5",
    stroke: "#816CD4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 107.017 46-49.638 14 4.5v45.138H0Z",
    fill: "#A390F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.433 19.784c-12.539-4.299-26.188 2.38-30.487 14.919L82.35 50.27c4.3-12.538-2.38-26.187-14.918-30.486Z",
    fill: "url(#empty-state_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.946 34.703 82.351 50.27l17.054 21.176L9.541 40.635l27.405-5.932Z",
    fill: "url(#empty-state_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.405 71.446 9.541 40.635C17.243 45.919 37 57.978 54.405 63.946c17.406 5.968 37.252 7.487 45 7.5Z",
    fill: "url(#empty-state_svg__c)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.716,
    cy: 26.095,
    r: 4.5,
    transform: "rotate(18.925 56.716 26.095)",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-state_svg__a",
    x1: 36.946,
    y1: 34.703,
    x2: 67.562,
    y2: 4.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45474B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-state_svg__b",
    x1: 11.892,
    y1: 33.777,
    x2: 101.757,
    y2: 64.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A390F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-state_svg__c",
    x1: 8.324,
    y1: 44.182,
    x2: 98.189,
    y2: 74.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC7171"
  })))));
};
export { SvgEmptyState as ReactComponent };
export default "data:image/svg+xml;base64,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";